import React, { useState } from 'react';
import {
  withRouter,
  NavLink,
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import _ from 'lodash';
import * as actions from './actions';
import * as c from './constants';

import BillsPaymentTransactionContainer from './container/BillsPaymentTransactionContainer';
import BillsPaymentDashboard from './container/BillsPaymentDashboardContainer';
// TODO: refactor later, check redundancies, etc..

const BillsPaymentContainer = ({
  getBillsList,
  billsList,
  pager,
  isLoading,
  permissions,
}) => {
  const match = useRouteMatch();
  const [formData, setFormData] = useState({});


  return (
    <div className="module-inner">
      <div className="module-inner-title">Bills Payment</div>
      <div className="generic-module-nav mb-3">
        {/* TODO: replace E-GOV with bills payment later */}
        {Acl(permissions, ['VIEW E-BILLS']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/e-bills"
          >
            Dashboard
          </NavLink>
        )}

        {Acl(permissions, ['VIEW E-BILLS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/e-bills/reports"
          >
            Reports
          </NavLink>
        )}

        {Acl(permissions, ['VIEW E-BILLS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/e-bills/payments"
          >
            Payments
          </NavLink>
        )}
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <BillsPaymentDashboard />}
        />
        <Route path={`${match.path}/reports`} render={() => (<div>Reports</div>)} />
        <Route
          path={`${match.path}/payments`}
          render={() => (
            <BillsPaymentTransactionContainer
              formData={formData}
              setFormData={setFormData}
              getBillsList={getBillsList}
              billsList={billsList}
              pager={pager}
              isLoading={isLoading}
            />
          )}
        />
      </Switch>
    </div>
  );
};

BillsPaymentContainer.propTypes = {
  getBillsList: PropTypes.instanceOf(Function).isRequired,
  billsList: PropTypes.instanceOf(Array).isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  //   pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  billsList: _.get(api, `${c.BILLS_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.BILLS_LIST) > -1,
  pager: _.get(api, `${c.BILLS_LIST}.pager`) || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BillsPaymentContainer);
